// Enum for table columns (API response fields)
export enum AllocatedTableColumn {
  SALES_LEAD_ID = "sales_lead_id",
  COMPANY_NAME = "company_name",
  REGION_NAME = "region_name",
  ADDRESS = "address",
  EMAIL = "email",
  TYPE_NAME = "type_name",
  INDUSTRY_NAME = "industry_name",
  ENQUIRY_CATEGORY_NAME = "enquiry_category_name",
  ALLOCATED_TO_NAME = "allocated_to_name",
  ALLOCATED_BY_NAME = "allocated_by_name",
  STATUS_TITLE_NAME = "status_title_name",
}

// Enum for export columns (backend expected fields)
export enum AllocatedExportColumn {
  SALES_LEAD_ID = "sales_lead_id",
  COMPANY_NAME = "company_name",
  REGION_NAME = "region__name",
  ADDRESS = "address",
  EMAIL = "email",
  TYPE_NAME = "type__name",
  INDUSTRY_NAME = "industry__name",
  ENQUIRY_CATEGORY_NAME = "enquiry_category__name",
  ALLOCATED_TO_NAME = "allocated_to_name",
  STATUS_TITLE_NAME = "status_title_name",
}

// Column display names mapping (for UI)
export const AllocatedColumnLabels: Record<AllocatedTableColumn, string> = {
  [AllocatedTableColumn.SALES_LEAD_ID]: "Code",
  [AllocatedTableColumn.COMPANY_NAME]: "Company",
  [AllocatedTableColumn.REGION_NAME]: "Region",
  [AllocatedTableColumn.ADDRESS]: "Contact",
  [AllocatedTableColumn.EMAIL]: "Email",
  [AllocatedTableColumn.TYPE_NAME]: "Type",
  [AllocatedTableColumn.INDUSTRY_NAME]: "Industry",
  [AllocatedTableColumn.ENQUIRY_CATEGORY_NAME]: "Enquiry Category",
  [AllocatedTableColumn.ALLOCATED_TO_NAME]: "Allocated To",
  [AllocatedTableColumn.ALLOCATED_BY_NAME]: "Allocated By",
  [AllocatedTableColumn.STATUS_TITLE_NAME]: "Status",
};

// Default selected columns for export (all true)
export const getDefaultAllocatedSelectedColumns = () => ({
  [AllocatedExportColumn.SALES_LEAD_ID]: true,
  [AllocatedExportColumn.COMPANY_NAME]: true,
  [AllocatedExportColumn.REGION_NAME]: true,
  [AllocatedExportColumn.ADDRESS]: true,
  [AllocatedExportColumn.EMAIL]: true,
  [AllocatedExportColumn.TYPE_NAME]: true,
  [AllocatedExportColumn.INDUSTRY_NAME]: true,
  [AllocatedExportColumn.ENQUIRY_CATEGORY_NAME]: true,
  [AllocatedExportColumn.ALLOCATED_TO_NAME]: true,
  [AllocatedExportColumn.STATUS_TITLE_NAME]: true,
});
